import React from 'react';
const testimonials = [{
  initials: 'JR',
  quote: 'I mapped out my whole school year in one night. Every single lesson now has a clear goal, and I walk into the gym knowing exactly what we are doing.',
  name: 'James R.',
  role: 'Primary PE Teacher · Sydney, Australia'
}, {
  initials: 'CM',
  quote: 'My students improved faster in two months than in the entire previous year. The skill progression just makes sense and the kids feel it.',
  name: 'Coach Mike',
  role: 'Middle School PE · Toronto, Canada'
}, {
  initials: 'SL',
  quote: 'I used to spend hours online searching for ideas. Now I open P.E. READY 360 and everything I need is right there. It is unbelievable.',
  name: 'Sarah L.',
  role: 'High School PE Teacher · Manchester, UK'
}, {
  initials: 'DT',
  quote: 'The evaluation sheets completely changed my conversations with parents. I finally talk in numbers and progress, and they trust the process.',
  name: 'David T.',
  role: 'PE Department Head · Chicago, USA'
}, {
  initials: 'EW',
  quote: 'As a first-year PE teacher I was completely overwhelmed. This gave me a full professional system from day one and my confidence in the gym doubled.',
  name: 'Emma W.',
  role: 'Junior PE Teacher · Auckland, NZ'
}, {
  initials: 'RB',
  quote: 'P.E. READY 360 saved me in so many difficult situations this year. Having those ready-made plans at my fingertips is an absolute game changer.',
  name: 'Ryan B.',
  role: 'Senior PE Coordinator · Dublin, Ireland'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-238">
      <div className="max-w-5xl mx-auto" data-id="element-239">
        <div className="text-center mb-12" data-id="element-240">
          <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] mb-3 tracking-tight" data-id="element-241">
            What <span className="text-[#FF6B00]" data-id="element-242">teachers</span> are saying
          </h2>
          <p className="text-[#5A5A66] text-base font-bold" data-id="element-243">
            ⭐⭐⭐⭐⭐ 4.9/5 · 500+ PE teachers worldwide
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-244">
          {testimonials.map((t, i) => <div key={i} className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 flex flex-col shadow-sm" data-id="element-245">
              <div className="flex items-center gap-3 mb-4" data-id="element-246">
                <div className="w-10 h-10 rounded-full bg-[#FF6B00] flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-247">
                  {t.initials}
                </div>
                <div className="text-[#FFD700] text-sm" data-id="element-248">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-[#0A0A0A] text-sm font-medium italic leading-relaxed mb-6 flex-1" data-id="element-249">
                "{t.quote}"
              </p>
              <div data-id="element-250">
                <p className="text-[#0A0A0A] font-black text-sm" data-id="element-251">{t.name}</p>
                <p className="text-[#5A5A66] text-xs font-semibold mt-0.5" data-id="element-252">
                  {t.role}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}